import Vue from 'vue'
import Router from 'vue-router'
import { Auth } from 'aws-amplify'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/pdf/Index'),
      children: [
        // Main uploader
        {
          name: 'Uploader',
          path: '',
          component: () => import('@/views/pdf/Uploader'),
          meta: { requiresAuth: true },
        },
        {
          name: 'About',
          path: 'about',
          component: () => import('@/views/pdf/About'),
        },
        {
          name: 'Help',
          path: 'help',
          component: () => import('@/views/pdf/Help'),
        },
        {
          name: 'Auth',
          path: 'auth',
          component: () => import('@/views/pdf/Auth'),
        },
        {
          name: 'Demo',
          path: 'demo',
          component: () => import('@/views/pdf/UploaderDemo'),
        },
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pdf/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pdf/Error'),
        },
      ],
    },
  ],
})

router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // let user
    Auth.currentAuthenticatedUser().then(data => {
      if (data && data.signInUserSession) {
        // user = data
      }
      next()
    }).catch((e) => {
      next({
        path: '/auth',
        query: {
          redirect: to.fullPath,
        },
      })
    })
  }
  next()
})

export default router
